// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 594 ? "about" : chunkId) + "." + {"228":"e0cd648a","439":"05672c61","521":"ee847f42","594":"b019027d"}[chunkId] + ".css";
};